import { useRef } from "react";
import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { CARE_STAGES } from "@/lib/site";

export default function CareTimeline() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.75", "end 0.55"] });
  const fill = useSpring(scrollYProgress, { stiffness: 60, damping: 20 });

  return (
    <div ref={ref} className="relative pl-12 sm:pl-16" data-testid="care-progression-timeline">
      <div className="absolute bottom-2 left-4 top-2 w-px bg-ivory/15 sm:left-6" aria-hidden="true">
        <motion.div
          className="h-full w-full origin-top bg-gold"
          style={reduce ? { scaleY: 1 } : { scaleY: fill }}
          data-testid="care-timeline-progress-line"
        />
      </div>
      <ol className="space-y-9">
        {CARE_STAGES.map((s, i) => (
          <li key={s.title} className="relative">
            <span
              className="absolute -left-12 top-0.5 flex h-8 w-8 items-center justify-center rounded-full border border-gold/60 bg-forest font-mono text-[11px] font-semibold text-gold sm:-left-16"
              data-testid={`care-stage-number-${i + 1}`}
            >
              {String(i + 1).padStart(2, "0")}
            </span>
            <Reveal y={16}>
              <p className="font-display text-2xl font-medium italic text-ivory sm:text-3xl" data-testid={`care-stage-title-${i + 1}`}>
                {s.title}
              </p>
              <p className="mt-1 text-sm uppercase tracking-[0.18em] text-ivory/60" data-testid={`care-stage-desc-${i + 1}`}>
                {s.desc}
              </p>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  );
}
